import './GoodToKnow.css';
import '../index.css'
import ImageCard from '../components/ImageCard';
import Spacer from '../components/Spacer.js'

function GoodToKnow() {
    let foodAndDrinks = (
        <div>
            <p className='card-small-text'>
                Middag kommer serveras som buffé och det kommer även serveras traditionsenlig bröllopstårta.
                Vi bjuder på dryck med och utan alkohol under middagen.
                I baren kommer det finnas alkohol till självkostnadspris.
                Mot småtimmarna kommer det även serveras lite vickning för att hålla energin uppe!
            </p>
            <p className='card-small-text'>
                Glöm inte att meddela eventuella allergier när ni svarar på inbjudan!
            </p>
        </div>
    )

    let accomodation = (
        <div>
            <p className='card-small-text'>
                För er som önskar övernatta i samband med festen finns det många bra boendealternativ i närheten av Lillegård.            </p>
            <p className='card-small-text'>
                Vi rekommenderar i första hand att bo i Lund, där det finns ett stort utbud av hotell och boenden via exempelvis Hotels.com eller andra bokningssidor. Malmö finns också som ett alternativ men ligger lite längre bort.</p>
            <p className='card-small-text'>
                För den som hellre vill bo närmare festlokalen har Lillegård även samarbeten med följande boenden i Kävlinge och Remmarlöv:
            </p>
            <p className='card-small-text'>
                <b><a href='https://torgetvandrarhem.se'>Torget Vandrarhem, Kävlinge</a></b><br></br>10% rabatt vid bokning via mail till bokning@torgetvandrarhem.se. Ange rabattkoden “Lillegård” i bokningsförfrågan.
            </p>
            <p className='card-small-text'>
                <b><a href='https://www.remmarlov.com/'>Bo i Remmarlöv</a></b><br></br>5% rabatt vid bokning av minst två rum. Bokning sker via mail till frank@remmarlov.se. Ange att bokningen gäller en fest på Lillegård.
            </p>
        </div>)

    let attire = (
        <p className='card-small-text'>
            Kavaj innebär för herrar att man ska bära kostym.
            Men val av färg både på kavajen och skjortan gör du själv.
            För damer innebär det klänning, kjol, byxdress eller dräkt. Undvik vitt då det är reserverat för bruden.
        </p>)

    let kids = (
        <p className='card-small-text'>
            Barn är underbara men den här dagen väljer vi att fira i vuxet sällskap.
        </p>)

    return (
        <div className='home-main'>
            <p className='home-main-text'>Bra Att Veta</p>
            <Spacer />
            <div className='image-cards-container'>
                <ImageCard
                    title="Mat och Dryck"
                    text={foodAndDrinks}
                    imagePath="/foodDrinks.png"
                    imageAlt="foodDrinks"
                />
                <ImageCard
                    title="Boende"
                    text={accomodation}
                    imagePath="/accomodation.png"
                    imageAlt="accomodation"
                />
            </div>
            <div style={{ height: 50 }}></div>
            <div className='image-cards-container'>
                <ImageCard
                    title="Klädsel - Kavaj"
                    text={attire}
                    imagePath="/dresscode.png"
                    imageAlt="dresscode"
                />
                <ImageCard
                    title="Barn"
                    text={kids}
                    imagePath="/kid.png"
                    imageAlt="kid"
                />
            </div>
            <Spacer />
        </div >
    );
}

export default GoodToKnow;
